import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import cirlogo from "../../images/cir-logo.png";
import { API_URL } from "../../../Config";
import { useParams } from "react-router-dom";
import {
  ModalHeader,
  Modal,
  ModalBody,
} from "reactstrap";

const PayInstallment = () => {
  const [installmentData, setInstallmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successModal, setsuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const successToggleModal = () => setsuccessModal(!successModal);

  const [loaderModal, setLoaderModal] = useState(false);
  const loaderToggle = () => setLoaderModal(!loaderModal);

  const { id } = useParams()
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    fetch(API_URL + "/get/installment/data/" + id)
      .then((res) => res.json())
      .then((data) => {
        const installment = data.data && data.data[0];
        setInstallmentData(installment || null);
        setLoading(false);
        if (installment && installment.status != 1) {
          payNow(installment)
        }
      })
      .catch((err) => {
        console.error("Error fetching installment data:", err);
        setLoading(false);
      });
  }


  const payNow = (installment) => {
    $("#paypal-button-container").html('')

    paypal
      .Buttons({
        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: parseFloat(installment.paymentAmount).toFixed(2),
                },
              },
            ],
          });
        },
        onApprove: function (data, actions) {
          return actions.order.capture().then(async function (details) {
            setErrorMessage("")
            setLoaderModal(true)
            try {
              const requestUrl = API_URL + "/complete/installment/payment/" + id
              const response = await fetch(requestUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  paymentDetails: details,
                }),
              });

              const data = await response.json();
              setLoaderModal(false)

              if (data.success) {
                setsuccessModal(true)
                getData()
              } else {
                setErrorMessage("Your payment was made but could not be recorded. Please contact us with PayPal order ID " + details.id + ".")
              }
            } catch (err) {
              console.error("Error recording installment payment:", err);
              setLoaderModal(false)
              setErrorMessage("Your payment was made but could not be recorded. Please contact us with PayPal order ID " + details.id + ".")
            }
          });
        },
        onCancel: function (data) {
        },
      })
      .render("#paypal-button-container");
  }

  return (
    <Box
      sx={{
        width: "600px",
        maxWidth: "100%",
        m: "0 auto",
        p: 1,
        mt: 5,
      }}
    >
      <Box>
        <div className="cir-logo" style={{ textAlign: "center" }}>
          <a href="/">
            <img src={cirlogo} alt="logo" />
          </a>
          <h5 style={{ fontSize: "24px", paddingTop: "1rem", color: "#818DCB" }}>
            Professional School of Behavioral Health Sciences
          </h5>
        </div>
        <Box
          sx={{
            border: "2px solid #818DCB",
            p: 2,
            mt: 4,
            flex: 1,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            width: "100%",
            borderRadius: "10px",
            "& p": {
              pb: 1,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              textAlign: "center",
              mb: 2,
              color: "#818DCB",
            }}
          >
            Pay Installment
          </Typography>

          {loading ? (
            <Typography textAlign={"center"}>Loading...</Typography>
          ) : !installmentData ? (
            <Typography sx={{ fontSize: "18px", textAlign: "center" }}>
              Installment not found.
            </Typography>
          ) : installmentData.status == 1 ? (
            <Typography sx={{ fontSize: "18px", textAlign: "center" }}>
              Payment for this installment has already been received.
            </Typography>
          ) : (
            <>
              <Typography sx={{ fontSize: "18px" }}>
                <b>Student Name</b>:{" "}
                {installmentData.firstname + " " + installmentData.lastname}
              </Typography>
              <Typography sx={{ fontSize: "18px" }}>
                <b>Course Name</b>: {installmentData.course_name}
              </Typography>
              <Typography sx={{ fontSize: "18px" }}>
                <b>Installment</b>: {installmentData.installmentNumber} of {installmentData.installmentCount}
              </Typography>
              <Typography sx={{ fontSize: "18px" }}>
                <b>Installment Amount</b>: ${installmentData.paymentAmount}
              </Typography>
              <Typography sx={{ fontSize: "18px", marginBottom: "20px" }}>
                <b>Installment Due Date</b>:{" "}
                {new Date(installmentData.paymentDate * 1000).toLocaleDateString(
                  "en-US",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }
                )}
              </Typography>
              {errorMessage && (
                <Typography sx={{ fontSize: "16px", color: "red" }}>
                  {errorMessage}
                </Typography>
              )}
              <div id="paypal-button-container"></div>
            </>
          )}

          <Modal
            isOpen={successModal}
            toggle={successToggleModal}
            className="connect-box"
            centered={true}
          >
            <ModalHeader toggle={successToggleModal}>
              <span className="ml-1 roititle font-weight-bold">Success</span>
            </ModalHeader>
            <ModalBody>
              <p style={{ textAlign: "center" }}>Thank You! Your payment has been received</p>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={loaderModal}
            toggle={loaderToggle}
            style={{ height: "700px" }}
            className="connect-box"
            centered={true}
          >
            <ModalHeader toggle={loaderToggle}>
              <span className="ml-1 roititle font-weight-bold">
                Processing Payment...
              </span>
            </ModalHeader>
            <ModalBody style={{ maxHeight: "700px" }}>
              <p style={{ textAlign: "center" }}>Please wait while we process your payment.</p>
            </ModalBody>
          </Modal>

        </Box>
      </Box>
    </Box>
  );
};

export default PayInstallment;
